import { setOrganizationUsers } from "../actions/auth";
import { appStore } from "../modules/store";
import { organizationStoreName } from "../reducers/organization";
import { LocalStorageKeys } from "../types/enums";
import { apiService } from "./rtkApi/apiService";
import { localStorageService } from "./local-storage-service";

/**
 * Clears RTK Query cache, auth org-user list, and related localStorage.
 * Call before Auth0 logout.
 */
export async function clearClientSessionOnLogout() {
  localStorageService.removeLocalStorage(organizationStoreName);

  localStorage.removeItem(LocalStorageKeys.AccessToken);
  localStorage.removeItem(LocalStorageKeys.OrganizationUserId);
  localStorage.removeItem(LocalStorageKeys.UserRoles);
  localStorage.removeItem(LocalStorageKeys.NameId);

  // Legacy redux-persist keys (safe to remove after upgrade)
  localStorage.removeItem("persist:account");
  localStorage.removeItem("persist:organization");
  localStorage.removeItem("persist:lookups");

  appStore.dispatch(setOrganizationUsers([]));
  appStore.dispatch(apiService.util.resetApiState());
}
